export enum RoleToTranslation {
    user = "USER",
    superuser = "SUPER_USER",
    localadmin = "LOCAL_ADMIN",
    nurse = "NURSE"
}